module.exports = __webpack_public_path__ + "static/img/组 2943.2cd33d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/组 2943.png
// module id = BUoi
// module chunks = 0